import { HeroImpact } from "../../../organisms/hero-impact/hero-impact";
import { ImpactList } from "../../../organisms/impact-list/impact-list";
import { Impact } from "../../../organisms/impact/impact";
import { ImplementedProposals } from "../../../organisms/implemented-proposals/implemented-proposals";
import { Feedback } from "../../../organisms/feedback/feedback";
import { CustomerMap } from "../../../organisms/customer-map/customer-map";

export const ImpactPage = () => {
  return (
    <div id="page" className="impact">
      <HeroImpact />

      <ImpactList />

      <div className="w-full flex mt-10 scale-75 -mb-24 lg:mb-0">
        <img
          src="/assets/images/impact/target.png"
          alt="Target"
          className="max-w-[435px] mx-auto"
        />
      </div>

      <Impact titleVisible={false} />
      <br />
      <CustomerMap title="O Nosso Alcance" showTitleIcons={false}/>
      <ImplementedProposals />
      <br />
      <Feedback schoolsPage={true} />
    </div>
  );
};

export default Impact;
